import { useMemo } from 'react'

import { buildTrack } from './buildTrack'
import { normalize } from './normalize'
import { shouldSendOnce } from './shouldSendOnce'

export function useAnalytics() {
  const track = useMemo(() => buildTrack(), [])

  return {
    ph: null,
    track,
    normalize,
    shouldSendOnce
  }
}
